<template>
  <v-dialog
    v-model="enable"
    max-width="400"
    persistent>
    <v-card
      v-if="inProgress">
      <v-card-title class="headline">
        登録中...
      </v-card-title>
      <v-card-text>
        メールアドレスの登録中です。しばらくお待ち下さい。
      </v-card-text>
      <v-card-actions>
        <v-progress-linear
          :indeterminate="true"
          color="primary"
        />
      </v-card-actions>
    </v-card>
    <v-card
      v-else>
      <v-card-title class="headline">
        確認メールを送信しました。
      </v-card-title>
      <v-card-text>
        メールを確認し、教師情報の登録を行ってください。
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color='primary'
          @click="reSend">
          メール再送信
        </v-btn>
        <v-btn
          color="primary"
          @click="finish">
          確認完了
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TeacherSignUpDialog',
  props: {
    enable: {
      type: Boolean,
      default: false,
      required: true
    },
    inProgress: {
      type: Boolean,
      default: true,
      required: true
    }
  },
  methods: {
    reSend() {
      this.$emit('reSend')
    },
    finish() {
      this.$emit('finish')
    }
  }
}
</script>
